<template>
  <v-container>
    <v-card>
      <v-card-title>Edit Profiling Question</v-card-title>
      <v-card-text>
        <div v-if="loading">Loading...</div>

        <div v-else-if="question">
          <!-- Basic Info -->
          <v-row>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="question.name"
                label="Name"
                outlined
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="question.category"
                label="Category"
                outlined
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                v-model="question.points"
                type="number"
                label="Points"
                outlined
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6">
              <v-switch
                v-model="question.isActive"
                label="Active"
                inset
              ></v-switch>
            </v-col>

            <v-col cols="12">
              <v-combobox
                v-model="question.countries"
                label="Countries"
                multiple
                chips
                outlined
              ></v-combobox>
            </v-col>

            <v-col cols="12">
              <v-img :src="question.image" max-width="200" class="mb-2"></v-img>
              <v-text-field
                v-model="question.image"
                label="Image URL"
                outlined
              ></v-text-field>
            </v-col>
          </v-row>

          <!-- Questions Section -->
          <v-divider class="my-4"></v-divider>
          <h3>Questions</h3>

          <v-expansion-panels multiple>
            <v-expansion-panel
              v-for="(q, index) in question.questions"
              :key="q._id + index"
            >
              <v-expansion-panel-title>
                {{ q.question.translations.en || "Untitled Question" }}
              </v-expansion-panel-title>
              <v-expansion-panel-text>
                <v-row>
                  <v-col cols="12" md="6">
                    <v-select
                      v-model="q.questionType"
                      :items="['radio', 'checkbox', 'text']"
                      label="Question Type"
                      outlined
                    ></v-select>
                  </v-col>

                  <v-col cols="12" md="6">
                    <v-text-field
                      v-model="q.profilingKey"
                      label="Profiling Key"
                      outlined
                    ></v-text-field>
                  </v-col>

                  <!-- Translations -->
                  <v-col
                    cols="12"
                    v-for="(val, lang) in q.question.translations"
                    :key="lang"
                  >
                    <v-text-field
                      v-model="q.question.translations[lang]"
                      :label="`Question (${lang.toUpperCase()})`"
                      outlined
                    ></v-text-field>
                  </v-col>
                </v-row>

                <!-- Options -->
                <!-- Options -->
                <v-divider class="my-2"></v-divider>
                <h4>Options</h4>
                <v-row v-for="(opt, i) in q.options" :key="i" class="mb-2">
                  <v-col cols="12" md="4">
                    <v-text-field
                      v-model="opt.value"
                      label="Value"
                      outlined
                    ></v-text-field>
                  </v-col>

                  <v-col cols="12" md="8">
                    <div
                      v-for="(txt, lang) in opt.text.translations"
                      :key="lang"
                    >
                      <v-text-field
                        v-model="opt.text.translations[lang]"
                        :label="`Option (${lang.toUpperCase()})`"
                        outlined
                      ></v-text-field>
                    </div>
                  </v-col>

                  <v-col cols="12" class="d-flex justify-end">
                    <v-btn icon color="red" @click="removeOption(index, i)">
                      <v-icon>mdi-delete</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <!-- Add option button -->
                <v-btn color="primary" small @click="addOption(index)">
                  Add Option
                </v-btn>
              </v-expansion-panel-text>
            </v-expansion-panel>
          </v-expansion-panels>
        </div>

        <div v-else>
          <p>No question found.</p>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="saveQuestion">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import RestResource from "../../../services/dataServiceMobileV2";

const service = new RestResource();

export default {
  name: "MobileV2ProfilingEdit",
  data() {
    return {
      question: null,
      loading: false,
    };
  },
  async created() {
    const id = this.$route.params.id;
    if (id) {
      await this.fetchQuestion(id);
    }
  },
  methods: {
    async fetchQuestion(id) {
      this.loading = true;
      try {
        this.$setLoader();
        const res = await service.getProfilingQuestionById({ id: id });

        console.log("Fetched question:", res.data.data);
        this.question = res.data.data;
      } catch (err) {
        console.error("Error fetching question:", err);
      } finally {
        this.loading = false;
        this.$disableLoader();
      }
    },
    addOption(qIndex) {
      if (!this.question.questions[qIndex].options) {
        this.$set(this.question.questions[qIndex], "options", []);
      }
      this.question.questions[qIndex].options.push({
        value: "",
        text: {
          translations: {
            en: "",
          },
        },
      });
    },

    removeOption(qIndex, oIndex) {
      this.question.questions[qIndex].options.splice(oIndex, 1);
    },
    async saveQuestion() {
      try {
        this.$setLoader();
        // filter empty translations like in your Add page
        const payload = {
          ...this.question,
          questions: this.question.questions.map((q) => ({
            ...q,
            question: {
              translations: Object.fromEntries(
                Object.entries(q.question.translations).filter(
                  ([, text]) => text && text.trim() !== ""
                )
              ),
            },
            options: q.options.map((o) => ({
              value: o.value,
              text: {
                translations: Object.fromEntries(
                  Object.entries(o.text.translations).filter(
                    ([, text]) => text && text.trim() !== ""
                  )
                ),
              },
            })),
          })),
        };

        console.log('pau', payload)

        await service.updateProfilingData(payload);
        this.$router.push({ name: "MobileV2ProfilingQuestion" });
      } catch (err) {
        console.error("Error saving question:", err);
      } finally {
        this.$disableLoader();
      }
    },
  },
};
</script>
